import { Button, Col, Container, Row } from 'react-bootstrap';
import DefaultCard from '../../../components/DefaultCard/DefaultCard';
import useModal from '../../../hooks/useModal';
import DeleteModal from './DeleteModal';

function DeleteModalDemo({ children }: any) {
  const [showModal, handleShow, handleClose] = useModal();

  return (
    <Container>
      <Container className="mt-10">
        <h4>Delete Modal</h4>
        <Container className="d-flex justify-content-between flex-wrap align-items-center p-0">
          <Button variant="primary" onMouseDown={handleShow}>
            Show Modal
          </Button>
          <DeleteModal
            showModal={showModal}
            handleClose={handleClose}
            handleSubmit={handleClose}
            title="Delete Address"
          >
            <Container>
              <Row>Are you sure you want to delete this address?</Row>
              <Row>
                <Col className="p-0 pt-4">
                  <DefaultCard
                    className="hi"
                    leftHeading="Lorem Ipsum"
                    leftSubheading="Lorem Ipsum"
                    rightHeading="Lorem Ipsum"
                    rightSubheading="Lorem Ipsum"
                  />
                </Col>
                <Col></Col>
              </Row>
            </Container>
          </DeleteModal>
        </Container>
      </Container>
    </Container>
  );
}

export default DeleteModalDemo;
